import { render, staticRenderFns } from "./member_orderdetail.vue?vue&type=template&id=16a38dfe&scoped=true"
import script from "./member_orderdetail.vue?vue&type=script&lang=js"
export * from "./member_orderdetail.vue?vue&type=script&lang=js"
import style0 from "./member_orderdetail.vue?vue&type=style&index=0&id=16a38dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a38dfe",
  null
  
)

export default component.exports